import React from "react";
import About from "./About";

export default function WhyGreen() {
  return <About title={"Why Green Right?"} />;
}
